import AppLogoIcon from "./app-logo-icon"

/**
 * AppLogo — the canonical OKS lockup (mark + "OKS Crew" wordmark).
 *
 * Composition (UX Spec §2):
 *   - Rounded tile on the left, `bg-sidebar-primary` (Orange Néon
 *     `#FF4D00`), with the `<AppLogoIcon>` "OKS" lockup rendered in
 *     `text-white` → white "OKS" letterforms on orange. Tile is height-
 *     constrained (`h-8` = 32px) and width-fits the lockup's ~3.13:1
 *     aspect ratio plus horizontal padding (≈ 75px wide overall).
 *   - Wordmark "OKS Crew" on the right, **Inter 700** (`font-bold`),
 *     leading-tight to match the tile height (TRD KD-9 — proper noun, not
 *     translated; rendered as text so screen readers pick it up natively
 *     per UX Spec §6). The mark + wordmark combination reads `[OKS] OKS
 *     Crew` — the mark identifies the company, the wordmark identifies
 *     this product.
 *
 * Source-of-truth: the wordmark string is the hardcoded literal "OKS
 * Crew". Crew is OKS-branded, not white-label, so no env-var indirection.
 *
 * Used by every brand/agency/admin sidebar header and the
 * `<AppSidebar>` fallback shell. Mark-only contexts (creator-shell,
 * auth-simple-layout, invite-landing, etc.) compose `<AppLogoIcon>`
 * directly without this lockup wrapper.
 */
export default function AppLogo() {
  return (
    <>
      <div className="bg-sidebar-primary text-sidebar-primary-foreground inline-flex h-8 items-center justify-center rounded-md px-2">
        <AppLogoIcon className="h-4 text-white" />
      </div>
      <div className="ml-2 grid flex-1 text-left text-sm">
        <span className="mb-0.5 truncate leading-tight font-bold">
          OKS Crew
        </span>
      </div>
    </>
  )
}
